import React, { Component } from "react";
import { Header, Divider, Segment } from "semantic-ui-react";
import "rc-pagination/assets/index.css";
import { withRouter } from "react-router-dom";
import LazyLoad from "react-lazyload";

class HowToSubmit extends Component {
  render() {
    return (
      <div style={{ width: "100%", paddingTop: "10px", textAlign: "center" }}>
        <Header as="h2">Steps</Header>
        <Segment>
          <Header as="h3">Step 1: Download app from respective store.</Header>
          <LazyLoad resize>
            <a href="https://play.google.com/store/apps/details?id=com.socialbookmarker">
              <img
              src={process.env.PUBLIC_URL + '/playstore.png'}
                style={{
                  width: "10%",
                  height: "10%"
                }}
              />
            </a>
            OR
            <a href="https://apps.apple.com/app/social-bookmarker/id1514832913">
            <img
              src={process.env.PUBLIC_URL + '/appstore.png'}
              style={{
                width: "9%",
                height: "10%",
              }}
            />
          </a>
          </LazyLoad>
          <Divider fitted />
          <Header as="h3">Step 2: Login or Register your account</Header>
          <LazyLoad resize>
            <img
            src={process.env.PUBLIC_URL + '/login.png'}
              style={{
                width: "15%",
                height: "15%"
              }}
            />
          </LazyLoad>
          <Divider fitted />
          <Header as="h3">
            Step 3: Navigate to submit url screen by click on plus screen
          </Header>
          <LazyLoad resize>
            <div>
              <img
              src={process.env.PUBLIC_URL + '/submitURL.png'}
                style={{
                  width: "15%",
                  height: "15%"
                }}
              />
            </div>
            OR
            <div>
              <img
              src={process.env.PUBLIC_URL + '/newFeed.png'}
                style={{
                  width: "15%",
                  height: "15%"
                }}
              />
            </div>
          </LazyLoad>
          <Divider fitted />
          <Header as="h3"> Step 4: Fill submit form</Header>
          <LazyLoad resize>
            <img
            src={process.env.PUBLIC_URL + '/fillForm.png'}
              style={{
                width: "15%",
                height: "15%"
              }}
            />
          </LazyLoad>
          <Divider fitted />
          <Header as="h3">
            Step 5: Submit back-links report to your email address
          </Header>
          <LazyLoad resize>
            <img
            src={process.env.PUBLIC_URL + '/sendEmail.png'}
              style={{
                width: "15%",
                height: "15%"
              }}
            />
          </LazyLoad>
        </Segment>
      </div>
    );
  }
}

export default withRouter(HowToSubmit);
